module.exports = __webpack_public_path__ + "img/Ansichten.75f3fc50.jpg";